import Select from 'react-select';

import styled from 'styled-components';
import { createStyledReactSelect } from '../../Atoms/Forms/StyledReactSelect/StyledReactSelect';

export const StyledSelect = styled(createStyledReactSelect(Select))``;
